import React from "react";
import { AppBar,  Container, Grid, Paper } from "@mui/material";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from "react-router-dom";
import Toolbar from '@mui/material/Toolbar';
import userService from "../../service/serviceUser";
import CustomizedBreadcrumbs from "../../component/breadcrumbs/breadcrumbs";
import SimpleBackdrop from "../../component/loading/loading";
import { Button } from "antd";
import TableUser from "../../component/table-user/table-user";
import DrawerPrincipal from "../../component/drawer/drawer-principal";


function User(){
    const [usuario, setUsuario] = useState(null);
    const [permission, setPermission] = useState(null);

    let navigate = useNavigate();

    const [listUser, setListUser] = useState({
        data: [],
        pagination: {
            currentPage: 1,
            totalPages: 0,
            totalItems: 0,
            itemsPerPage: 10,
            hasNext: false,
            hasPrev: false,
        }
    });

    const [loading, setLoading] = useState(1);
    const [open, setOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [filters, setFilters] = useState({});
    const [sortBy, setSortBy] = useState(null);
    const [sortOrder, setSortOrder] = useState(null);

    useEffect(() => {
        try {
            const userToken = localStorage.getItem("user_token");
            if (userToken) {
                const userData = JSON.parse(userToken);
                setUsuario(userData);
                setPermission(userData?.roles?.filter((item) => item.name == "Usuario")[0] || null);
            }
        } catch (error) {
            console.error("Erro ao carregar dados do usuário:", error);
        }
    }, []);

    useEffect(() => {
        if (!usuario) return;

        (async () => {
            setOpen(true);

            try {
                const item = await userService.listarUser(1, 500);

                if (item && item.success !== false) {
                    // Se a API retorna dados paginados
                    if (item.data && Array.isArray(item.data) && item.pagination) {
                        setListUser({
                            data: item.data,
                            pagination: item.pagination,
                        });
                    }
                    // Se a API retorna apenas um array (compatibilidade)
                    else if (Array.isArray(item)) {
                        setListUser({
                            data: item,
                            pagination: {
                                currentPage: 1,
                                totalPages: 0,
                                totalItems: 0,
                                itemsPerPage: 10,
                                hasNext: false,
                                hasPrev: false,
                            }
                        });
                    }
                    else {
                        console.error("Resposta inválida da API:", item);
                        setListUser({
                            data: [],
                            pagination: {
                                currentPage: 1,
                                totalPages: 0,
                                totalItems: 0,
                                itemsPerPage: 10,
                                hasNext: false,
                                hasPrev: false,
                            }
                        });
                    }
                }
                else if (item && item.success === false) {
                    console.error("Erro na API:", item.message);
                    setErrorMessage(item.message);
                    setListUser({
                        data: [],
                        pagination: {
                            currentPage: 1,
                            totalPages: 0,
                            totalItems: 0,
                            itemsPerPage: 10,
                            hasNext: false,
                            hasPrev: false,
                        }
                    });
                }
                else {
                    console.error("Resposta inválida da API:", item);
                    setListUser({
                        data: [],
                        pagination: {
                            currentPage: 1,
                            totalPages: 0,
                            totalItems: 0,
                            itemsPerPage: 10,
                            hasNext: false,
                            hasPrev: false,
                        }
                    });
                }
            } catch (error) {
                console.error("Erro na requisição:", error);
                setListUser({
                    data: [],
                    pagination: {
                        currentPage: 1,
                        totalPages: 0,
                        totalItems: 0,
                        itemsPerPage: 10,
                        hasNext: false,
                        hasPrev: false,
                    }
                });
                setErrorMessage(error.message || "Erro ao carregar usuários");
            } finally {
                setOpen(false);
                setLoading(0);
            }
        })();
    }, [usuario]);

    const handleClose = () => {
        setOpen(false);
    };

    const loadPage = async (page, pageSize, customFilters, customSortBy, customSortOrder) => {
        // Se customFilters foi passado explicitamente, usa ele; senão usa o estado
        const filtersToUse = customFilters !== undefined ? customFilters : filters;
        const sortByToUse = customSortBy !== undefined ? customSortBy : sortBy;
        const sortOrderToUse = customSortOrder !== undefined ? customSortOrder : sortOrder;
        
        console.log("🔄 [ListUser] Carregando página:", page, "Tamanho:", pageSize);
        console.log("🔍 [ListUser] customFilters recebido:", customFilters);
        console.log("🔍 [ListUser] filters do estado:", filters);
        console.log("🔍 [ListUser] Filtros que serão usados:", filtersToUse);
        console.log("📊 [ListUser] Ordenação:", sortByToUse, sortOrderToUse);
        
        setOpen(true);
        
        try {
            const item = await userService.listarUser(
                page, 
                pageSize, 
                filtersToUse,
                sortByToUse,
                sortOrderToUse
            );
            console.log("📡 [ListUser] Resposta da API:", item);
            
            if (item && item.success !== false) {
                if (item.data && Array.isArray(item.data) && item.pagination) {
                    console.log("✅ [ListUser] Dados recebidos:", {
                        dataLength: item.data.length,
                        pagination: item.pagination,
                        filters: filtersToUse
                    });
                    setListUser({
                        data: item.data,
                        pagination: item.pagination,
                    });
                }
            } else {
                console.error("❌ [ListUser] Erro na API:", item);
                setErrorMessage(item?.message || "Erro ao carregar dados");
            }
        } catch (error) {
            console.error("❌ [ListUser] Erro ao carregar dados:", error);
            setErrorMessage(error.message || "Erro ao carregar dados");
        } finally {
            setOpen(false);
        }
    };

    const handleFilterChange = (newFilters) => {
        console.log("🔍 [ListUser] Filtros alterados:", newFilters);
        console.log("🔍 [ListUser] Chamando API IMEDIATAMENTE com novos filtros");
        
        // Atualizar estado
        setFilters(newFilters);
        
        // Recarregar dados com novos filtros IMEDIATAMENTE (não espera setState)
        // Passa newFilters diretamente, não usa o estado
        loadPage(1, listUser.pagination.itemsPerPage || 10, newFilters);
    };

    const handleSortChange = (newSortBy, newSortOrder) => {
        console.log("📊 [ListUser] Ordenação alterada:", newSortBy, newSortOrder);
        
        // Atualizar estados
        setSortBy(newSortBy);
        setSortOrder(newSortOrder);
        
        // Recarregar dados com nova ordenação
        loadPage(
            listUser.pagination.currentPage || 1,
            listUser.pagination.itemsPerPage || 10,
            filters,
            newSortBy,
            newSortOrder
        );
    };

    if (!usuario) {
        return (
            <Container maxWidth="lx" sx={{ bgcolor: "#EBEBEB", height: "100vh" }}>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                    <SimpleBackdrop open={true} handleClose={() => {}} title={"Carregando usuário..."} />
                </div>
            </Container>
        );
    }

    return (
        <>
            <Container maxWidth="lx" sx={{ bgcolor: '#EBEBEB', height: '100vh' }}>
                
                <DrawerPrincipal title={"Usuário"} divOpen={
                    <div>
                        <div>
                            <SimpleBackdrop
                                open={open}
                                handleClose={handleClose}
                                title={"Carregando informações..."}
                            />
                            <div className="row mb-3">
                                <CustomizedBreadcrumbs title1={"Home"} link1={"/"} 
                                        title2={"Lista de Usuários"} link2={"#"} />
                            </div>
                            <Paper sx={{width: '100%', margin: 'auto', overflow: 'hidden' }}>

                                    <AppBar
                                        position="static"
                                        color="default"
                                        elevation={0}
                                        sx={{ borderBottom: '1px solid rgba(0, 0, 0, 0.12)' }}
                                        >
                                        <Toolbar>
                                        <Grid container spacing={2} alignItems="center">
                                                <Grid item style={{width: 200}}>
                                                <h5>Lista de Usuários</h5>
                                                </Grid>
                                                <Grid item xs>
                                                </Grid>
                                                <Grid item>
                                                </Grid>
                                                <Grid item>
                                                    {
                                                        permission?.isinsert ? 
                                                        <Link to={"/newUser"}>
                                                            <Button style={{background: 'black', color: '#FFF'}} sx={{ mr: 1 }}>
                                                                <AddIcon /> Novo
                                                            </Button>
                                                        </Link>
                                                        : 
                                                        ""
                                                    }
                                                </Grid>
                                            </Grid>
                                        </Toolbar>
                                    </AppBar>

                                    <div style={{ width: '100%', padding: 10 }}>
                                        {errorMessage && (
                                            <div
                                                style={{
                                                    padding: "10px",
                                                    marginBottom: "10px",
                                                    backgroundColor: "#ffebee",
                                                    color: "#c62828",
                                                    border: "1px solid #ef5350",
                                                    borderRadius: "4px",
                                                }}
                                            >
                                                <strong>Erro:</strong> {errorMessage}
                                            </div>
                                        )}

                                        <TableUser 
                                            data={listUser} 
                                            onPageChange={loadPage}
                                            onFilterChange={handleFilterChange}
                                            onSortChange={handleSortChange}
                                        />
                                    </div>
                            </Paper>
                        </div>
                    </div>
                }/>
            </Container>
        </>
    );
}


export default User;